(()=>{'use strict';
  const hero=document.querySelector('#top.estate-camera');
  const sticky=hero?.querySelector('.estate-camera__sticky');
  if(!hero||!sticky)return;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  let frame=0,lastFinish=-10000,lastDirection=0,touch=null,reverseIntent=0;
  const bounds=()=>{
    const styles=getComputedStyle(document.documentElement);
    const scene=parseFloat(styles.getPropertyValue('--estate-scene-height'))||sticky.clientHeight;
    const runway=parseFloat(styles.getPropertyValue('--estate-runway'))||sticky.clientHeight;
    const top=hero.getBoundingClientRect().top+window.scrollY;
    const leadIn=Math.max(0,scene-sticky.clientHeight);
    return {start:top,end:top+leadIn+runway};
  };
  // A gentle sinusoidal ease distributes the motion across the whole gesture.
  // The previous cubic ease held almost still before accelerating abruptly.
  const ease=t=>.5-.5*Math.cos(Math.PI*t);
  // Progress is bounded PER RENDERED FRAME rather than jumping ahead by the
  // entire amount of time the main thread was blocked. When a frame takes
  // 70–150ms, we display the intervening gate artwork instead of skipping it.
  // This preserves the original easing, journey distance and both endpoints.
  const MAX_STEP_MS=26;
  function finish(){
    frame=0;
    window.EstateHeroGestureActive=false;
    lastFinish=performance.now();
    reverseIntent=0;
  }
  function animate(to){
    lastDirection=Math.sign(to-scrollY);
    reverseIntent=0;
    if(frame)cancelAnimationFrame(frame);
    const from=scrollY,change=to-from;
    if(Math.abs(change)<2){finish();return;}
    // Retain the approved scroll duration and sinusoidal ease. Clamping the
    // elapsed time *per frame* only extends it when rendering is overloaded.
    const duration=Math.min(2390,Math.max(1930,Math.abs(change)*1.02))/1.2;
    let elapsed=0,lastTick=0;
    window.EstateHeroGestureActive=true;
    function tick(now){
      if(reduce.matches){window.EstateHeroGestureActive=false;frame=0;return;}
      if(!lastTick)lastTick=now;
      const delta=Math.max(0,now-lastTick);
      lastTick=now;
      elapsed=Math.min(duration,elapsed+Math.min(delta,MAX_STEP_MS));
      const progress=elapsed/duration;
      const y=progress>=1?to:from+change*ease(progress);
      window.scrollTo(0,y);
      // Render the camera in the SAME rAF as the scroll position, not on a
      // second rAF queued by the scroll event. This also fixes reverse frames.
      window.EstateHeroPaintNow?.(now);
      if(progress<1){frame=requestAnimationFrame(tick);}
      else finish();
    }
    frame=requestAnimationFrame(tick);
  }
  function maybeComplete(direction,position){
    if(reduce.matches)return false;
    const {start,end}=bounds();
    const y=position??scrollY;
    // Only capture the hero's camera runway, not the lyrical CTA/other pages.
    if(direction>0&&y>=start-8&&y<end-90){animate(end);return true;}
    if(direction<0&&y>start+90&&y<=end+55){animate(start);return true;}
    return false;
  }
  addEventListener('wheel',event=>{
    if(event.ctrlKey||Math.abs(event.deltaY)<=Math.abs(event.deltaX)||Math.abs(event.deltaY)<2)return;
    const now=performance.now();
    if(frame){
      event.preventDefault();
      // Trackpads emit tiny opposite-sign momentum samples. Require a real
      // reverse gesture before interrupting the ongoing camera pass.
      if(Math.sign(event.deltaY)!==lastDirection){
        reverseIntent+=Math.abs(event.deltaY)*(event.deltaMode===1?16:event.deltaMode===2?innerHeight:1);
        if(reverseIntent>=24)maybeComplete(Math.sign(event.deltaY),scrollY);
      }else reverseIntent=0;
      return;
    }
    // Once the gate zoom completes, allow the very next native wheel event
    // into Section 2. The old 340ms suppressed it near the end of the hero,
    // which felt like a scroll lock on trackpads (particularly Safari).
    // Momentum from the previous gesture must not start a second hero zoom.
    if(now-lastFinish<180 && Math.sign(event.deltaY)===lastDirection){
      const {start,end}=bounds();
      if(lastDirection>0 && scrollY>=end-3)return;
      if(lastDirection<0 && scrollY<=start+3)return;
      return;
    }
    const {start,end}=bounds(),y=scrollY;
    const direction=Math.sign(event.deltaY);
    // On the way back from Section 2, capture the camera near the seam,
    // before one big wheel delta skips the first reverse zoom frames.
    if(direction<0 && y>end+55){
      const dy=event.deltaY*(event.deltaMode===1?16:event.deltaMode===2?innerHeight:1);
      if(y<=end+Math.min(innerHeight*.22,180) && y+dy<=end+55){
        event.preventDefault();
        animate(start);
        return;
      }
    }
    if((direction>0&&y>=start-8&&y<end-90)||(direction<0&&y>start+90&&y<=end+55)){
      event.preventDefault();maybeComplete(direction,y);
    }
  },{passive:false});
  // On touch screens intercept only a vertical swipe that begins in the
  // hero runway. Horizontal gestures and controls keep native handling.
  addEventListener('touchstart',event=>{
    if(reduce.matches||event.touches.length!==1||event.target.closest('a,button,input,textarea,select')){touch=null;return;}
    const {start,end}=bounds();
    if(scrollY<start-8||scrollY>end+55){touch=null;return;}
    const p=event.touches[0];touch={x:p.clientX,y:p.clientY,at:scrollY,dir:0,locked:false};
  },{passive:true});
  addEventListener('touchmove',event=>{
    if(!touch||event.touches.length!==1)return;
    const p=event.touches[0],dx=p.clientX-touch.x,dy=p.clientY-touch.y;
    if(!touch.locked&&Math.abs(dy)>10&&Math.abs(dy)>Math.abs(dx)*1.4){
      touch.locked=true;touch.dir=dy<0?1:-1;
    }
    // Never prevent native touch scrolling if the camera is already at the
    // corresponding edge. Otherwise the intro feels completely locked on iOS.
    if(touch.locked&&event.cancelable){
      const {start,end}=bounds();
      const canZoom=touch.dir>0?touch.at<end-90:touch.at>start+90;
      if(canZoom)event.preventDefault();
    }
  },{passive:false});
  addEventListener('touchend',()=>{
    if(touch?.locked&&touch.dir)maybeComplete(touch.dir,touch.at);
    touch=null;
  },{passive:true});
  addEventListener('touchcancel',()=>{touch=null;},{passive:true});
})();
